export default __webpack_public_path__ + "static/media/logo-dark.00808457.svg";